module.exports = __webpack_public_path__ + "media/process/Process2-52ff7051.jpg";